<template>
  <div>

  <b-row align-v="end" align-h="start">
    <b-col cols="2">
      <md-field md-clearable>
        <label>{{$t('Type to Search')}}</label>
        <md-input v-model="filter" @update="filterChanged"></md-input>
      </md-field>
    </b-col>

    <b-col cols="1" style="max-width: 80px;">
      <md-field>
        <md-select v-model="perPage" @md-selected="paginationChanged">
          <md-option v-for="item in pageOptions" :key="item" :value="item"> {{ item }} </md-option>
        </md-select>
      </md-field>
    </b-col>

    <b-col cols="2.5" v-if="!filterOptions.isDataRangeDisabled">
      <b-row>
        <b-col style="max-width: 200px;">
          <md-field>
          <flat-picker
            class="md-input-report"
            ref="DPstart"
            style="font-size:16px"
            @onDateChanged="onChangedDateStart"
            @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(new Date()/1000 ).toDate())}"
          />
          </md-field>
        </b-col>
        <b-col style="max-width: 200px;">
          <md-field>
            <flat-picker
              class="md-input-report"
              ref="DPend"
              style="font-size:16px"
              @onDateChanged="onChangedDateEnd"
              @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(new Date()/1000 ).toDate())}"
            />
          </md-field>
        </b-col>
      </b-row>
    </b-col>

    <b-col cols="1"  v-if="filterOptions.isTelephonyReport" >
      <md-field>
        <md-switch v-model="isAlternativeDate" @md-selected="isAlternativeDateChanged" style="margin:0"/>
        <div style="margin-left: 5px;">
          {{$t('By call')}}
        </div>
      </md-field>
    </b-col>

    <b-col cols="2" style="max-width: 200px;" v-if="!filterOptions.isTimeSpanDisabled">
      <md-field>
        <label for="selected">{{$t('Time Span')}}</label>
        <md-select v-model="selected">
          <md-option v-for="item in optionsTime" :key="item.value" :value="item.value"> {{ item.text }} </md-option>
        </md-select>
      </md-field>
    </b-col>

    <b-col cols="1"  v-if="!filterOptions.isNotLimit" style="max-width: 100px;">
      <md-field>
        <label for="limitRows">{{$t('Rows limit')}}</label>
        <md-select v-model="limitRows" @md-selected="limitRowsChanged">
          <md-option v-for="item in limitOptions" :key="item" :value="item"> {{ item }} </md-option>
        </md-select>
      </md-field>
    </b-col>

    <b-col v-if="filterOptions.isFilterGroup" cols="1">
      <md-field>
        <label for="selectGroup">{{$t('Groups')}}</label>
        <md-select v-model="selectGroup">
          <md-option v-for="item in optionsGroup" :key="item.value" :value="item.value"> {{ item.text }} </md-option>
        </md-select>
      </md-field>
    </b-col>

    <b-col v-if="filterOptions.isFilterAccsGroup" cols="1">
      <md-field>
        <label for="selectAccsGroup">{{$t('Accs groups')}}</label>
        <md-select v-model="selectAccsGroup">
          <md-option v-for="item in optionsAccsGroup" :key="item.value" :value="item.value"> {{ item.text }} </md-option>
        </md-select>
      </md-field>
    </b-col>

  </b-row>
  <b-row>

    <b-col cols="1" v-if="filterOptions.isFilterTypeDocuments" md="auto">
      <md-field>
        <label for="selectTypeDocuments">{{$t('Type documents')}}</label>
        <md-select v-model="selectTypeDocuments">
          <md-option v-for="item in optionsDocuments" :key="item.value" :value="item.value"> {{ item.text }} </md-option>
        </md-select>
      </md-field>
    </b-col>

    <b-col cols="3" v-if="filterOptions.isFilterTypeUsers">
      <md-field>
        <label for="selectTypeUsers">{{$t('Type')}}</label>
        <md-select v-model="selectTypeUsers">
          <md-option v-for="item in optionsTypeUseres" :key="item.value" :value="item.value"> {{ item.text }} </md-option>
        </md-select>
      </md-field>
    </b-col>

    <b-col cols="1" v-if="filterOptions.isFilterTypeTraffic" md="auto">
      <md-field>
        <label for="selectTypeTraffic">{{$t('Type')}}</label>
        <md-select v-model="selectTypeTraffic">
          <md-option v-for="item in optionsTraffic" :key="item.value" :value="item.value"> {{ item.text }} </md-option>
        </md-select>
      </md-field>
    </b-col>

    <b-col cols="2" v-if="filterOptions.isFilterCollector" >
      <md-field>
        <label for="selectCollector">{{$t('Traffic collector')}}</label>
        <md-select v-model="selectCollector">
          <md-option v-for="item in optionsCollector" :key="item.value" :value="item.value"> {{ item.text }} </md-option>
        </md-select>
      </md-field>
    </b-col>
  </b-row>
  <b-row style="margin: 6px 2px;">

    <b-col cols="0.5" v-if="!filterOptions.isGenereteButtonDisabled">
        <md-button block @click.stop="generate" class="md-raised" size="sm" :disabled="isGenerateDisabled">{{ $t('Generate') }}</md-button>
    </b-col>

    <b-col cols="0.5" v-if="filterOptions.isDownloadable">
      <md-button @click.stop="download" class="md-raised" size="sm" v-if="filterOptions.isDownloadable"  :disabled="isDownloadDisabled">{{ $t('Export') }}</md-button>
    </b-col>

    <b-col cols="0.5" v-if="filterOptions.isActions">
      <md-button id="actionsID" class="md-raised" size="sm" v-if="filterOptions.isDownloadable" >{{ $t('Actions') }}</md-button>
      <b-popover target="actionsID" triggers="click" placement="right">
        <template #title>{{ $t('Document actions') }}</template>

        <li style="list-style-type: none;">
          <md-button @click.stop="downloadAs('pdf')" class="md-raised" >{{ $t('Download as pdf') }}</md-button>
        </li>
        <li style="list-style-type: none;">
          <md-button @click.stop="downloadAs('odt')" class="md-raised" >{{ $t('Download as odt') }}</md-button>
        </li>

      </b-popover>
    </b-col>
  </b-row>
  </div>
</template>

<style>
.md-input-report > .form-control.input {
  border: 0px;
}
.md-field {
  margin: 6px 8px;
}
</style>

<script>

export default {
  props: {
    filterOptions: {
      isGenereteButtonDisabled: false,
      isTimeSpanDisabled: false,
      isDataRangeDisabled: false,
      isFilterGroup: false,
      isFilterAccsGroup: false,
      isFilterTypeTraffic: false,
      isFilterTypeDocuments: false,
      isFilterTypeUsers: false,
      isFilterCollector: false,
      isDownloadable: false,
      isActions: false,
      isNotLimit: false,
      isTelephonyReport: false
    },
    isGenerateDisabled: false,
    isDownloadDisabled: false
  },
  data () {
    return {
      from: 0,
      to: 0,
      selectCollector: 0,
      selectTypeTraffic: 0,
      selectTypeUsers: 0,
      selectTypeDocuments: 1,
      selectGroup: 0,
      selectAccsGroup: 0,
      optionsCollector: [],
      filter: '',
      pageOptions: [20, 40, 60, 80, 100],
      limitOptions: [500, 1000, 5000, 0],
      perPage: 20,
      limitRows: 500,
      dateStart: Date('1969-01-01'),
      dateEnd: Date('2050-10-10'),
      selected: 0,
      isAlternativeDate: false,
      optionsTraffic: [
        { text: '---', value: 0 },
        { text: this.$i18n.t('Gruopped by hour'), value: 1 },
        { text: this.$i18n.t('Gruopped by day'), value: 2 },
        { text: this.$i18n.t('Gruopped by month'), value: 3 },
        { text: this.$i18n.t('Gruopped by IPv4'), value: 4 },
        { text: this.$i18n.t('Gruopped by group'), value: 5 },
        { text: this.$i18n.t('Gruopped by IPv6'), value: 6 }
      ],
      optionsDocuments: [
        { text: this.$i18n.t('Invoice'), value: 1 },
        { text: this.$i18n.t('VAT invoice'), value: 2 },
        { text: this.$i18n.t('Acceptance report'), value: 4 },
        { text: this.$i18n.t('Detail invoice'), value: 7 } ],
      optionsTime: [
        { text: this.$i18n.t('Current Day'), value: 0 },
        { text: this.$i18n.t('Current Week'), value: 1 },
        { text: this.$i18n.t('Current Month'), value: 2 },
        { text: this.$i18n.t('Current Year'), value: 3 },
        { text: this.$i18n.t('Manually'), value: 4 }
      ],
      optionsTypeUseres: [
        { text: this.$i18n.t('All'), value: 0 },
        { text: this.$i18n.t('Correction of invoice positions'), value: 1 },
        { text: this.$i18n.t('Balance correction'), value: 2 },
        { text: this.$i18n.t('Adding user'), value: 3 },
        { text: this.$i18n.t('Editing user'), value: 4 },
        { text: this.$i18n.t('Deleting user'), value: 5 },
        { text: this.$i18n.t('Adding IP Group'), value: 6 },
        { text: this.$i18n.t('Editing IP group'), value: 7 },
        { text: this.$i18n.t('Adding user group'), value: 8 },
        { text: this.$i18n.t('Deleting user group'), value: 9 },
        { text: this.$i18n.t('Editing user group'), value: 10 },
        { text: this.$i18n.t('Adding user to group'), value: 11 },
        { text: this.$i18n.t('Removing user from group'), value: 12 },
        { text: this.$i18n.t('Adding account'), value: 13 },
        { text: this.$i18n.t('Editing account'), value: 14 },
        { text: this.$i18n.t('Adding service'), value: 15 },
        { text: this.$i18n.t('Editing service'), value: 16 },
        { text: this.$i18n.t('Users group operations'), value: 17 },
        { text: this.$i18n.t('Adding tariff'), value: 18 },
        { text: this.$i18n.t('Editing tariff'), value: 19 },
        { text: this.$i18n.t('Deleting tariff'), value: 20 },
        { text: this.$i18n.t('Adding service to tariff'), value: 21 },
        { text: this.$i18n.t('Deleting service from tariff'), value: 22 },
        { text: this.$i18n.t('Unlinking tariff from account'), value: 23 },
        { text: this.$i18n.t('Linking tariff to account'), value: 24 },
        { text: this.$i18n.t('Adding additional settings parameter'), value: 25 },
        { text: this.$i18n.t('Editing additional settings parameter'), value: 26 },
        { text: this.$i18n.t('Deleting additional settings parameter'), value: 27 },
        { text: this.$i18n.t('Instant tariff change'), value: 28 },
        { text: this.$i18n.t('Policy change'), value: 29 },
        { text: this.$i18n.t('Additing technical parameter'), value: 30 },
        { text: this.$i18n.t('Editing technical parameter'), value: 31 },
        { text: this.$i18n.t('Deleting technical parameter'), value: 32 },
        { text: this.$i18n.t('Cost coefficient change'), value: 37 }
      ]
    }
  },
  watch: {
    filter: function (val) {
      this.$emit('filterChanged', val)
    },
    selectGroup: function (val) {
      this.$emit('onChangedGroup', val)
    },
    selectAccsGroup: function (val) {
      this.$emit('onChangeAccsGroup', val)
    },
    selectTypeDocuments: function (val) {
      this.$emit('onChangedTypeDocuments', val)
    },
    selectTypeUsers: function (val) {
      this.$emit('onChangedTypeUsers', val)
    },
    selectTypeTraffic: function (val) {
      this.$emit('onChangedTypeTraffic', val)
    },
    selectCollector: function (val) {
      this.$emit('onChangedCollector', val)
    },
    isAlternativeDate: function (val) {
      this.$emit('isAlternativeDateChanged', val)
    },
    selected: function (val) {
      var currentDate = this.$root.setDataWithSelectedTZ()
      switch (val) {
        case 0 :
          this.dateStart = currentDate.startOf('day').unix()
          this.dateEnd = currentDate.endOf('day').unix()
          break
        case 1 :
          this.dateStart = currentDate.startOf('isoweek').unix()
          this.dateEnd = currentDate.endOf('isoweek').unix()
          break
        case 2 :
          this.dateStart = currentDate.startOf('month').unix()
          this.dateEnd = currentDate.endOf('month').unix()
          break
        case 3 :
          this.dateStart = currentDate.startOf('year').unix()
          this.dateEnd = currentDate.endOf('year').unix()
          break
        case 4 :
          this.dateStart = currentDate.startOf('month').unix()
          this.dateEnd = currentDate.unix()
      }
      this.$emit('onChangedDateStart', new Date(this.dateStart * 1000))
      this.$emit('onChangedDateEnd', new Date(this.dateEnd * 1000))
      this.$refs.DPstart.setDate(new Date(this.dateStart * 1000))
      this.$refs.DPend.setDate(new Date(this.dateEnd * 1000))
    }
  },
  methods: {
    async loadCollector () {
      await this.$store.dispatch('Settings/GET_COLLECTORS', this.getStore).then(response => {
        let optionsCollector = this.$store.getters['Settings/COLLECTORS']
        for (let el of optionsCollector) {
          let newEl = {
            value: 0,
            text: ''
          }
          newEl.value = el.id
          newEl.text = el.name + ' (' + el.comments + ')'
          this.optionsCollector.push(newEl)
        }
        let newEl = {
          value: 0,
          text: '---'
        }
        this.optionsCollector.push(newEl)
      })
    },
    setFilter (filter) {
      this.filter = filter
    },
    filterChanged () {
      this.$emit('filterChanged', this.filter)
    },
    paginationChanged () {
      this.$emit('paginationChanged', this.perPage)
    },
    limitRowsChanged () {
      this.$emit('limitChanged', this.limitRows)
    },
    onChangedDateStart (date) {
      this.$emit('onChangedDateStart', date * 1000)
    },
    onChangedDateEnd (date) {
      this.$emit('onChangedDateEnd', date * 1000)
    },
    isAlternativeDateChanged (val) {
      this.$emit('isAlternativeDateChanged', val)
    },
    generate () {
      this.$emit('generate')
    },
    download () {
      this.$emit('download')
    },
    downloadAs (type) {
      this.$emit('downloadAs', type)
    }

  },
  computed: {
    perPageTitle () {
      let width = window.innerWidth
      if (width > 1485) {
        return this.$i18n.t('Per page')
      } else {
        return ''
      }
    },
    optionsGroup () {
      let tmp = []
      let newEl = {
        value: 0,
        text: '---'
      }
      tmp.push(newEl)
      for (let el of this.$store.getters['Users/GROUPS']) {
        let newEl = {
          value: 0,
          text: ''
        }
        newEl.value = el.group_id
        newEl.text = el.group_name
        tmp.push(newEl)
      }
      return tmp
    },
    optionsAccsGroup () {
      let tmp = []
      tmp.push({
        value: 0,
        text: '---'
      })
      for (let el of this.$store.getters['Users/ACCOUNTS_GROUPS']) {
        let newEl = {
          value: 0,
          text: ''
        }
        newEl.value = el.group_id
        newEl.text = el.group_name
        tmp.push(newEl)
      }
      return tmp
    }
  },
  mounted () {
    this.selected = 2
    if (this.filterOptions.isFilterGroup && this.$store.getters['Users/GROUPS'].length === 0) {
      this.$store.dispatch('Users/GET_GROUPS')
    }
    if (this.filterOptions.isFilterAccsGroup && this.$store.getters['Users/ACCOUNTS_GROUPS'].length === 0) {
      this.$store.dispatch('Users/GET_ACCOUNTS_GROUPS')
    }
    if (this.filterOptions.isFilterCollector) {
      this.loadCollector()
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/tables/ReportHeader.vue